'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record;

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _attachmentTypes = require('../constants/attachmentTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FileAttachment = (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, _messageTypes.MESSAGE_TYPE_ID, _attachmentTypes.FILES), _defineProperty(_Record, 'fileIds', (0, _immutable.List)()), _Record), 'FileAttachment');

exports.default = FileAttachment;
module.exports = exports['default'];